export {
    default as ButtonsFactory,
    type ButtonsFactoryProps,
} from './ButtonsFactory';
